import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { Button } from "@/DesignSystem";

import styles from "./LoginMultifactorAuthenticationPopup.module.scss";

interface ILoginMultifactorAuthenticationIsMandatoryPopupProps {
    stringProvider?: ResourceProvider;
    onClickMultifactorAuthenticationSetup: () => void;
}

function LoginMultifactorAuthenticationIsMandatoryPopup(props: Readonly<ILoginMultifactorAuthenticationIsMandatoryPopupProps>): JSX.Element {
    const { getText } = useTranslation(props.stringProvider);
    const rehypeRawPlugin: any = rehypeRaw;
    function renderFooter(): JSX.Element {
        return (
            <div className={styles.footerContainer}>
                <Button
                    variant="brand"
                    category="primary"
                    label={getText("LoginMultifactorAuthenticationSetUp_SetUpButton")}
                    onClick={props.onClickMultifactorAuthenticationSetup}
                    dataCy="login-MultifactorAuthenticationSetUpButton"
                />
            </div>
        );
    }

    function renderHeader(): JSX.Element {
        return (
            <div className={styles.popupTitle}>
                {getText("LoginMultifactorAuthenticationSetUp_Title")}
            </div>
        );
    }

    return (
        <Modal
            header={renderHeader()}
            centerContent
            fixedOverlayPosition
            showOverlay
            disableOverlayClose
            footer={renderFooter()}
            dataCy="login-MultifactorAuthenticationIsMandatoryPopup"
        >
            <div>
                <ReactMarkdown rehypePlugins={[rehypeRawPlugin]}>
                    {getText("LoginMultifactorAuthenticationSetUp_Explanation")}
                </ReactMarkdown>
                <br />
                <ReactMarkdown rehypePlugins={[rehypeRawPlugin]}>
                    {getText("LoginMultifactorAuthenticationSetUp_MandatoryPopupMessage")}
                </ReactMarkdown>
            </div>
        </Modal>
    );
}

export { LoginMultifactorAuthenticationIsMandatoryPopup };
